import { Action } from '@ngrx/store';
import { Reference } from '../../utils/action-helper.util';
import { Error } from '../_models/auth.models';
import { CheckNodeResponse, CopyProcessResponse, Process, ProcessError, ProcessRecordDetails } from '../_models/notification.model';

/**
 * Process action types
 */
export enum ProcessActionTypes {
  LOAD_PROCESSS = '[Process] Load Processs',
  LOAD_PROCESSS_SUCCESS = '[Process] Load Processs Success',
  LOAD_PROCESSS_FAILED = '[Process] Load Processs Failed',
  DELETE_PROCESS = '[Process] Delete Process',
  DELETE_PROCESS_SUCCESS = '[Process] Delete Process Success',
  DELETE_PROCESS_FAILED = '[Process] Delete Process Failed',
  UPDATE_PROCESS = '[Process] Update Process',
  UPDATE_PROCESS_SUCCESS = '[Process] Update Process Success',
  UPDATE_PROCESS_FAILED = '[Process] Update Process Failed',
  BULK_UPDATE_PROCESS = '[Process] Bulk Update Process',
  BULK_UPDATE_PROCESS_SUCCESS = '[Process] Bulk Update Process Success',
  BULK_UPDATE_PROCESS_FAILED = '[Process] Bulk Update Process Failed',
  ACTIVATE_PROCESS = '[Process] Activate Process',
  ACTIVATE_PROCESS_SUCCESS = '[Process] Activate Process Success',
  ACTIVATE_PROCESS_FAILED = '[Process] Activate Process Failed',
  CREATE_PROCESS = '[Process] Create Process',
  CREATE_PROCESS_SUCCESS = '[Process] Create Process Success',
  CREATE_PROCESS_FAILED = '[Process] Create Process Failed',
  COPY_PROCESS = '[Process] Copy Process',
  COPY_PROCESS_SUCCESS = '[Process] Copy Process Success',
  COPY_PROCESS_FAILED = '[Process] Copy Process Failed',
  LOAD_PROCESS = '[Process] Load Process',
  LOAD_PROCESS_SUCCESS = '[Process] Load Process Success',
  LOAD_PROCESS_FAILED = '[Process] Load Process Failed',
  VIEW_PROCESS_DETAILS = '[Process] View Process Details',
  VIEW_PROCESS_DETAILS_SUCCESS = '[Process] View Process Details Success',
  VIEW_PROCESS_DETAILS_FAILED = '[Process] View Process Details Failed',
  VIEW_PROCESS_RECORD = '[Process] View Process Record',
  VIEW_PROCESS_RECORD_SUCCESS = '[Process] View Process Record Success',
  VIEW_PROCESS_RECORD_FAILED = '[Process] View Process Record Failed',
  VIEW_PROCESS_ERROR = '[Process] View Process Error',
  VIEW_PROCESS_ERROR_SUCCESS = '[Process] View Process Error Success',
  VIEW_PROCESS_ERROR_FAILED = '[Process] View Process Error Failed',
  DELETE_PROCESS_ERROR = '[Process] Delete Process Error',
  DELETE_PROCESS_ERROR_SUCCESS = '[Process] Delete Process Error Success',
  DELETE_PROCESS_ERROR_FAILED = '[Process] Delete Process Error Failed',
  CHECK_NODE_ACTION = '[Process] Check Node Action',
  CHECK_NODE_ACTION_SUCCESS = '[Process] Check Node Action Success',
  CHECK_NODE_ACTION_FAILED = '[Process] Check Node Action Failed',
  RESET_CHECK_NODE = '[Process] Reset Check Node Failed',
  RESET = '[Process] RESET',
}

/**
 * Operations
 */
export class LoadProcesss implements Action {
  readonly type = ProcessActionTypes.LOAD_PROCESSS;

  constructor(public tableId: string, public force:boolean = false, public inReports: boolean = false) {}
}

export class LoadProcesssSuccess implements Action {
  readonly type = ProcessActionTypes.LOAD_PROCESSS_SUCCESS;

  constructor(public tableId: string, public payload: Array<Process>) {}
}

export class LoadProcesssFailed implements Action {
  readonly type = ProcessActionTypes.LOAD_PROCESSS_FAILED;

  constructor(public payload: Error, public tableId: string) {}
}

export class DeleteProcess extends Reference implements Action {
  readonly type = ProcessActionTypes.DELETE_PROCESS;

  constructor(public tableId: string, public processId: string) {
    super();
  }
}

export class DeleteProcessSuccess extends Reference implements Action {
  readonly type = ProcessActionTypes.DELETE_PROCESS_SUCCESS;

  constructor(public tableId: string, public processId: string) {
    super();
  }
}

export class DeleteProcessFailed extends Reference implements Action {
  readonly type = ProcessActionTypes.DELETE_PROCESS_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class UpdateProcess extends Reference implements Action {
  readonly type = ProcessActionTypes.UPDATE_PROCESS;

  constructor(public payload: Process, public tableId: string = '') {
    super();
  }
}

export class UpdateProcessSuccess extends Reference implements Action {
  readonly type = ProcessActionTypes.UPDATE_PROCESS_SUCCESS;

  constructor() {
    super();
  }
}

export class UpdateProcessFailed extends Reference implements Action {
  readonly type = ProcessActionTypes.UPDATE_PROCESS_FAILED;

  constructor(public payload: Error) {
    super();
  }
}
export class BulkUpdateProcess extends Reference implements Action {
  readonly type = ProcessActionTypes.BULK_UPDATE_PROCESS;

  constructor(public payload: any) {
    super();
  }
}

export class BulkUpdateProcessSuccess extends Reference implements Action {
  readonly type = ProcessActionTypes.BULK_UPDATE_PROCESS_SUCCESS;

  constructor(private payload:any) {
    super();
  }
}

export class BulkUpdateProcessFailed extends Reference implements Action {
  readonly type = ProcessActionTypes.BULK_UPDATE_PROCESS_FAILED;

  constructor(public payload: Error) {
    super();
  }
}
export class ActivateProcess extends Reference implements Action {
  readonly type = ProcessActionTypes.ACTIVATE_PROCESS;

  constructor(public payload: Process, public tableId: string = '') {
    super();
  }
}

export class ActivateProcessSuccess extends Reference implements Action {
  readonly type = ProcessActionTypes.ACTIVATE_PROCESS_SUCCESS;

  constructor(public payload: any, public tableId: string = '') {
    super();
  }
}

export class ActivateProcessFailed extends Reference implements Action {
  readonly type = ProcessActionTypes.ACTIVATE_PROCESS_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class CreateProcess extends Reference implements Action {
  readonly type = ProcessActionTypes.CREATE_PROCESS;

  constructor(public payload: Process) {
    super();
  }
}

export class CreateProcessSuccess extends Reference implements Action {
  readonly type = ProcessActionTypes.CREATE_PROCESS_SUCCESS;

  constructor(public payload: Process) {
    super();
  }
}

export class CreateProcessFailed extends Reference implements Action {
  readonly type = ProcessActionTypes.CREATE_PROCESS_FAILED;

  constructor(public payload: Error) {
    super();
  }
}
export class ViewProcessError implements Action {
  readonly type = ProcessActionTypes.VIEW_PROCESS_ERROR;

  constructor(public processId: string, public force: boolean = false) {}
}

export class ViewProcessErrorSuccess implements Action {
  readonly type = ProcessActionTypes.VIEW_PROCESS_ERROR_SUCCESS;

  constructor(
    public processId: string,
    public payload: Array<ProcessError>
  ) {}
}

export class ViewProcessErrorFailed implements Action {
  readonly type = ProcessActionTypes.VIEW_PROCESS_ERROR_FAILED;

  constructor(public payload: Error) {}
}

export class DeleteProcessError extends Reference implements Action {
  readonly type = ProcessActionTypes.DELETE_PROCESS_ERROR;

  constructor(public processId: string) {
    super();
  }
}

export class DeleteProcessErrorSuccess
  extends Reference
  implements Action
{
  readonly type = ProcessActionTypes.DELETE_PROCESS_ERROR_SUCCESS;

  constructor(public processId: string) {
    super();
  }
}

export class DeleteProcessErrorFailed extends Reference implements Action {
  readonly type = ProcessActionTypes.DELETE_PROCESS_ERROR_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class LoadProcess implements Action {
  readonly type = ProcessActionTypes.LOAD_PROCESS;

  constructor(
    public tableId: string,
    public processId: any,
    public force: boolean = false
  ) {}
}

export class LoadProcessSuccess implements Action {
  readonly type = ProcessActionTypes.LOAD_PROCESS_SUCCESS;

  constructor(
    public tableId: string,
    public processId: string,
    public payload: Process
  ) {}
}

export class LoadProcessFailed implements Action {
  readonly type = ProcessActionTypes.LOAD_PROCESS_FAILED;

  constructor(public payload: Error) {}
}
export class ViewProcessDetails implements Action {
  readonly type = ProcessActionTypes.VIEW_PROCESS_DETAILS;

  constructor(
    public tableId: string,
    public reportId: any,
    public recordId: any,
    public force: boolean = false
  ) {}
}

export class ViewProcessDetailsSuccess implements Action {
  readonly type = ProcessActionTypes.VIEW_PROCESS_DETAILS_SUCCESS;

  constructor(
    public tableId: string,
    public reportId: string,
    public recordId: string,
    public payload: Process
  ) {}
}

export class ViewProcessDetailsFailed implements Action {
  readonly type = ProcessActionTypes.VIEW_PROCESS_DETAILS_FAILED;

  constructor(public payload: Error) {}
}
export class ViewProcessRecordDetails extends Reference  implements Action {
  readonly type = ProcessActionTypes.VIEW_PROCESS_RECORD;

  constructor(
    public tableId: string,
    public reportId: any,
    public recordId: any,
    public force: boolean = false
  ) {
    super();
  }
}

export class ViewProcessRecordDetailsSuccess extends Reference  implements Action {
  readonly type = ProcessActionTypes.VIEW_PROCESS_RECORD_SUCCESS;

  constructor(
    public tableId: string,
    public reportId: string,
    public recordId: string,
    public payload: ProcessRecordDetails
  ) {
    super();
  }
}

export class ViewProcessRecordDetailsFailed extends Reference  implements Action {
  readonly type = ProcessActionTypes.VIEW_PROCESS_RECORD_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

export class Reset implements Action {
  readonly type = ProcessActionTypes.RESET;

  constructor() {}
}
export class ResetNodeAction implements Action {
  readonly type = ProcessActionTypes.RESET_CHECK_NODE;

  constructor() {}
}

export class CopyProcess extends Reference implements Action {
  readonly type = ProcessActionTypes.COPY_PROCESS;

  constructor(public tableId: string, public payload: any) {
    super();
  }
}

export class CopyProcessSuccess extends Reference implements Action {
  readonly type = ProcessActionTypes.COPY_PROCESS_SUCCESS;

  constructor(public payload: CopyProcessResponse) {
    super();
  }
}

export class CopyProcessFailed extends Reference implements Action {
  readonly type = ProcessActionTypes.COPY_PROCESS_FAILED;

  constructor(public payload: Error) {
    super();
  }
}
export class CheckNode extends Reference implements Action {
  readonly type = ProcessActionTypes.CHECK_NODE_ACTION;

  constructor(public tableId: string, public payload: any) {
    super();
  }
}

export class CheckNodeSuccess extends Reference implements Action {
  readonly type = ProcessActionTypes.CHECK_NODE_ACTION_SUCCESS;

  constructor(public tableId:string,public payload: CheckNodeResponse) {
    super();
  }
}

export class CheckNodeFailed extends Reference implements Action {
  readonly type = ProcessActionTypes.CHECK_NODE_ACTION_FAILED;

  constructor(public payload: Error) {
    super();
  }
}

/**
 * Available types
 */
export type Actions =
  | LoadProcesss
  | LoadProcesssSuccess
  | LoadProcesssFailed
  | DeleteProcess
  | DeleteProcessSuccess
  | DeleteProcessFailed
  | UpdateProcess
  | UpdateProcessSuccess
  | UpdateProcessFailed
  | BulkUpdateProcess
  | BulkUpdateProcessSuccess
  | BulkUpdateProcessFailed
  | ActivateProcess
  | ActivateProcessSuccess
  | ActivateProcessFailed
  | CreateProcess
  | CreateProcessSuccess
  | CreateProcessFailed
  | ViewProcessError
  | ViewProcessErrorSuccess
  | ViewProcessErrorFailed
  | DeleteProcessError
  | DeleteProcessErrorSuccess
  | DeleteProcessErrorFailed
  | LoadProcess
  | LoadProcessSuccess
  | LoadProcessFailed
  | ViewProcessDetails
  | ViewProcessDetailsSuccess
  | ViewProcessDetailsFailed
  | ViewProcessRecordDetails
  | ViewProcessRecordDetailsSuccess
  | ViewProcessRecordDetailsFailed
  | CopyProcess
  | CopyProcessSuccess
  | CopyProcessFailed
  | CheckNode
  | CheckNodeSuccess
  | CheckNodeFailed
  | ResetNodeAction
  | Reset;
